import React from "react";

import { styled } from "@mui/material";

import Header from "./Header";

interface Props {
  chatId: string;
  fromProfile?: boolean;
}

const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  paddingLeft: 2,
});

const Layout: React.FC<Props> = ({ chatId, children, fromProfile = false }) => {
  return (
    <Root
      style={{
        overflowY: fromProfile ? "hidden" : "auto",
        margin: fromProfile ? "0 10px" : 0,
      }}
    >
      <Header fromProfile={fromProfile} chatId={chatId} />
      {children}
    </Root>
  );
};

export default Layout;
